/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Later_LeadInputs */

const en_us2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or leave it for later: it moves to the end of the workout.`)
};

const pt_br2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou deixe para depois: vai para o fim do treino.`)
};

const es_419_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O déjalo para después: pasa al final del entrenamiento.`)
};

const pt_pt2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou deixa para depois: passa para o fim do treino.`)
};

const fr_fr2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou garde-le pour plus tard : il passe à la fin de la séance.`)
};

const de_de2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder später machen: Sie rückt ans Ende des Trainings.`)
};

const it_it2_swap_later_lead = /** @type {(inputs: Swap_Later_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppure lascialo per dopo: va alla fine dell'allenamento.`)
};

/**
* | output |
* | --- |
* | "Or leave it for later: it moves to the end of the workout." |
*
* @param {Swap_Later_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_later_lead = /** @type {((inputs?: Swap_Later_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Later_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_later_lead(inputs)
	if (locale === "es-419") return es_419_swap_later_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_later_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_later_lead(inputs)
	if (locale === "de-DE") return de_de2_swap_later_lead(inputs)
	if (locale === "it-IT") return it_it2_swap_later_lead(inputs)
	return en_us2_swap_later_lead(inputs)
});
export { swap_later_lead as "swap.later_lead" }